import React, { useMemo, useState } from "react";
import Masked from "common/Masked";
import Table from "common/graphs/Table/Table";
import styled from "styled-components";

const TableContainer = styled.div`
  width: 100%;
  .toolbar {
    display: block !important;
    width: 100%;
    .toolbar-right {
      justify-content: flex-end;
      align-items: center;
    }
    .toolbar-left {
      justify-content: flex-start;
      align-items: center;
    }
  }
`;

const doesNothing = () => {};

const getColumns = (onDelete) => {
  return [
    {
      label: "USER",
      id: "username",
      numeric: false,
    },
    {
      label: "SECRET",
      id: "password",
      numeric: false,
      renderCell: (value) => <Masked value={value} />,
    },
    {
      label: "ACTIONS",
      id: "ACTIONS",
      actions: [
        {
          label: "Delete",
          icon: "delete",
          onClick: (row) => onDelete([row["__id"]]),
        },
      ],
    },
  ];
};

const UsersList = ({ items = [], onDelete = doesNothing }) => {
  const [selected, setSelected] = useState([]);
  const columns = useMemo(() => getColumns(onDelete), [onDelete]);

  const filteredItems = items.filter(({ deleted }) => deleted !== true).map((item, index) => ({
    ...item,
    id: item.__id !== undefined ? item.__id : index
  }));

  return (
    <TableContainer>
      <Table
        columns={columns}
        data={filteredItems}
        exportCSV={false}
        isSelectable={true}
        isRowSelectable={false}
        selected={selected}
        setSelected={setSelected}
        deleteSelected={(values) => {
          onDelete(values);
          setSelected([]);
        }}
      />
    </TableContainer>
  );
};
export default UsersList;
